import React from "react";

const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = React.useState(
        () => typeof window !== "undefined" && window.matchMedia(query).matches,
    );

    React.useEffect(() => {
        const mediaQuery = window.matchMedia(query);
        const handleChange = () => setMatches(mediaQuery.matches);

        handleChange();
        mediaQuery.addEventListener("change", handleChange);

        return () => mediaQuery.removeEventListener("change", handleChange);
    }, [query]);

    return matches;
};

export default useMediaQuery;
